import { useMemo } from "react";
import styled from "styled-components";
import { COLOR_PRIMARY, COLOR_RED } from "../../constants/color";
import { CheckboxIcon } from "./icons/CheckboxIcon";

type CheckboxVariant = "filled" | "empty";

type Props = {
  name: string;
  variant: CheckboxVariant;
  checked?: boolean;
  label?: string;
};

export const PreviewCheckbox: React.FC<Props> = ({
  name,
  label,
  checked = false,
  variant,
}) => {
  const fillColor = useMemo(() => {
    if (checked) return COLOR_PRIMARY;
    return "#E6E6E6";
  }, []);

  return (
    <StyledCheckboxContainer
      $variant={variant}
      $isChecked={checked}
    >
      <StyledCheckboxContent>
        <CheckboxIcon fillColor={fillColor} />
        <StyledLabel
          $variant={variant}
          $isChecked={checked}
        >
          {label}
        </StyledLabel>
      </StyledCheckboxContent>

    </StyledCheckboxContainer>
  );
};

const StyledCheckboxContainer = styled.div<{
  $variant: CheckboxVariant;
  $isChecked: boolean;
  $hasError?: boolean;
}>`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  ${({ $variant, $isChecked, $hasError }) =>
    $variant === "filled" &&
    `
      padding: 14px 20px;
      border-radius: 8px;
      border: 1px solid ${
        $hasError ? COLOR_RED : $isChecked ? COLOR_PRIMARY : "#CCCCCC"
      };
      background-color: #FFFFFF;
    `}
`;

const StyledLabel = styled.div<{
  $variant: CheckboxVariant;
  $isChecked: boolean;
  $hasError?: boolean;
}>`
  color: ${({ $isChecked }) =>
    $isChecked ? COLOR_PRIMARY : "#333333"};
  font-size: 14px;
  font-weight: ${({ $variant }) => ($variant === "filled" ? 700 : 400)};
  line-height: 100%;
`;

const StyledCheckboxContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;
